// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
  margin-bottom: 12px;
  /* stylelint-disable-next-line*/
  _:-ms-fullscreen,
  .image-wrapper img {
    max-height: 100%;
  }
  ${(props) => props.isNewPJPPDPRedesignEnabled && '  width: 133px;min-width:133px;'}
  @media (min-width:1800px) {
    ${(props) => !props.isMiniPDP && '  width: 137px;min-width:137px;'}
  }
  ${(props) => props.isMiniPDP && '  width: 55px;min-width:55px;'}
  .image-wrapper {
    ${(props) =>
      props.isNewPJPPDPRedesignEnabled
        ? `box-sizing: border-box;
    position: relative;
    width: 100%;
    padding-top: 124%;`
        : `height: 100%;
    width: 90px;`}

    display: inline-flex;
    border: 1px solid ${(props) => props.theme.colors.WHITE};
    &.selected-image {
      border: 1px solid ${(props) => props.theme.colors.BORDER.NORMAL};
    }
    img {
      display: inherit;
      height: 100%;
      width: 100%;
      ${(props) =>
        props.isNewPJPPDPRedesignEnabled
          ? `position: absolute;
          top: 50%;
          left: 50%;
          box-sizing: border-box;
          transform: translate3d(-50%, -50%, 0);`
          : ``}
    }
  }
  .thumbnail {
    position: relative;
  }
  .thumbnail-play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 35px;
  }
`;
